import { render } from "./FeaturePageLayout.vue?vue&type=template&id=24778bd6"
import script from "./FeaturePageLayout.vue?vue&type=script&lang=js"
export * from "./FeaturePageLayout.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__